module.exports = __webpack_public_path__ + "img/preview_one_line_text.687bcff9.png";